'use client';

import { useEffect } from 'react';
import { warmUpApi } from '../lib/api';

/**
 * Invisible component that warms up the API on mount.
 * Place this on any page where users might navigate to /upload.
 */
export function ApiWarmup() {
  useEffect(() => {
    warmUpApi();
  }, []);

  return null;
}
